import { c as _c } from "react/compiler-runtime";
import { classNames } from "@opensea/ui-kit";
// This component's purpose is to wrap a card button that's used
// with a tooltip. It forwards the border radius as well as
// adding a solid background so that the disabled button doesn't
// leak through to the cards
export function TooltipButtonWrapper(t0) {
  const $ = _c(10);
  let children;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames("w-full bg-bg-app *:rounded-inherit", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== rest || $[8] !== t1) {
    t2 = <span className={t1} {...rest}>{children}</span>;
    $[6] = children;
    $[7] = rest;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}